import React from "react";

const UpdateIcon = ({ size = 16, className = "text-black" }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.003 14.667h4c3.333 0 4.666-1.334 4.666-4.667V6c0-3.333-1.333-4.667-4.666-4.667h-4C2.669 1.333 1.336 2.667 1.336 6v4c0 3.333 1.333 4.667 4.667 4.667"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11.67 8a3.665 3.665 0 0 1-3.667 3.667c-2.027 0-3.26-2.04-3.26-2.04m0 0h1.653m-1.653 0v1.833M4.336 8a3.656 3.656 0 0 1 3.667-3.667c2.446 0 3.666 2.04 3.666 2.04m0 0V4.54m0 1.833h-1.626"
        />
      </svg>
    </span>
  );
};

export default UpdateIcon;
